export default {
  title: {
    create: 'Create Service Data',
    detail: 'Service Details'
  },
  headers: {
    no: 'Service Code',
    name: 'Service Name',
    category: 'Category',
    type: 'Type',
    status: 'Status',
    sale: 'Sale'
  },
  label: {
    nameTh: 'Service Name (TH)',
    nameEn: 'Service Name (EN)',
    myCourse: 'My Services',
    noCourseData: 'No Service Data Found',
    getTreatmentServices: 'Receive Treatment / Service',
    create: 'Create Service',
    cutStock: 'Stock Deduction',
    cutStockList: 'Stock Deduction Item List',
    serviceTime: 'Service Duration',
    minute: 'minutes',
    noneTime: 'No Service Timer Required',
    showOnOpdPage: 'Show on OPD Page',
    hasStock: 'Has Stock',
    hasDFCharge: 'Has DF Fee Items',
    dfChargeList: 'DF Fee Items List',
    productAndFormulaList: 'Product and Medicine Formula List',
    dfChargeType: 'DF Fee Calculation Method',
    additionalFromServiceCharge: 'Additional to Service Fee',
    includedInServiceCharge: 'Included in Service Fee',
    showMedicationFormulaInOpd: 'Show Medication Formula on OPD Page',
    showItemsInInvoice: 'Show Items on Invoice',
    paymentProof: 'Payment Proof .pdf',
    showQuantityInReceipt: 'Show Quantity on Receipt',
    enterFeeByDoctor: 'Enter DF Fee by Doctor',
    category: 'Service Category',
    categoryName: 'Service Category Name',
    PDS: 'Product, Formula, and Service Items'
  },
  placeholder: {
    searchName: 'Search Service Name',
    searchIdName: 'Search Service Code or Name',
    enterId: 'Enter Service Code',
    enterInfo: 'Enter Service Information',
    nameTh: 'Enter Service Name (TH)',
    nameEn: 'Enter Service Name (EN)',
    cutStockList: 'Select Stock Deduction Items',
    enterDF: 'Enter DF Fee Items',
    serviceTime: 'Enter Service Duration',
    showOnOpdPage: 'Show on OPD Page',
    hasStock: 'Has Stock',
    hasDFCharge: 'Has DF Fee Items',
    dfChargeList: 'DF Fee Items List',
    productAndFormulaList: 'Select Product and Medicine Formula Items',
    selectedLabelItems: 'Select Items to Show on Medicine Label',
    dfChargeType: 'DF Fee Calculation Method',
    additionalFromServiceCharge: 'Additional to Service Fee',
    includedInServiceCharge: 'Included in Service Fee',
    enterFer: 'Enter DF Fee',
    category: 'Enter Service Category',
    enterCategory: 'Enter Service Category',
    searchCategory: 'Search Service Category Name'
  },
  toolTip: {
    create: 'Create Service',
    edit: 'Edit Service',
    delete: 'Delete Service',
    view: 'View Service Information',
    searchIdName: 'Search Service Code or Name'
  },
  modal: {
    create: {
      title: 'Create Service Data',
      success: 'Service Created Successfully',
      category: {
        success: 'Service Category Added Successfully'
      }
    },
    edit: {
      title: 'Edit Service Data',
      success: 'Service Edited Successfully',
      category: {
        success: 'Service Category Edited Successfully'
      }
    },
    delete: {
      title: 'Delete Service',
      content1: 'You are deleting the service',
      content2: 'Do you want to continue?',
      confirm: 'Confirm Service Deletion',
      cancel: 'Cancel',
      success: 'Service Deleted Successfully',
      category: {
        title: 'Confirm Service Category Deletion',
        subTitle: 'You are deleting a service category. Do you want to continue?',
        success: 'Service Category Deleted Successfully'
      }
    }
  }
}
